import { createApp } from 'vue'
import App from './views/app/app.vue'
import './registerServiceWorker'
import router from './router'
import { store } from './store'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import cookieBanner from './silktide/plugins/cookieBanner'

createApp(App).use(Quasar, quasarUserOptions).use(store).use(router).use(cookieBanner).mount('#app')